import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

// Desktop top navigation — shown only on md+ screens
export default function DesktopNav() {
  const navigate    = useNavigate();
  const { pathname } = useLocation();
  const { isLoggedIn, role, logout } = useAuth();

  const isActive = (path) =>
    path === '/' ? pathname === '/' : pathname.startsWith(path);

  const navLinks = [
    { path: '/',             label: 'Home',         icon: 'fa-house' },
    { path: '/search',       label: 'Find Doctor',  icon: 'fa-magnifying-glass' },
    { path: '/appointments', label: 'Appointments', icon: 'fa-calendar-check' },
    { path: '/chats',        label: 'Chats',        icon: 'fa-comment-dots' },
  ];

  return (
    <div className="hidden md:flex items-center gap-1">
      {navLinks.map(link => (
        <button key={link.path} onClick={() => {
          if (!isLoggedIn && link.path !== '/' && link.path !== '/search') {
            sessionStorage.setItem('loginOrigin', window.location.pathname);
            navigate('/login'); return;
          }
          navigate(link.path);
        }}
          className={`flex items-center gap-1.5 px-3 py-2 rounded-xl text-sm font-medium transition-all ${
            isActive(link.path)
              ? 'text-primary bg-primary/8'
              : 'text-text-secondary hover:text-primary hover:bg-surface'
          }`}>
          {link.label}
        </button>
      ))}

      {/* Login/Logout on desktop */}
      {isLoggedIn ? (
        <button onClick={() => {
            logout();
            if (role === 'doctor' || role === 'staff') navigate('/doctor/login');
            else navigate('/');
          }}
          className="ml-2 flex items-center gap-1.5 px-3 py-2 rounded-xl text-sm font-medium text-danger hover:bg-red-50 transition-all">
          <i className="fa-solid fa-right-from-bracket text-sm" />
          Logout
        </button>
      ) : (
        <button onClick={() => { sessionStorage.setItem('loginOrigin', window.location.pathname); navigate('/login', { state: { from: window.location.pathname } }); }}
          className="ml-2 bg-primary text-white text-sm font-semibold px-4 py-2 rounded-xl hover:bg-primary/90 transition-all shadow-sm">
          Login
        </button>
      )}
    </div>
  );
}
